import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import withIconWrapper from 'app/hocs/withIconWrapper';

export default withIconWrapper(function TryDifferentEmail({ color, size, ...props }) {
  return (
    <Svg fill="none" height={size} viewBox="0 0 20 15" width={size} {...props}>
      <Path
        d="M2.03571 0.75H17.4643C17.4643 0.75 18.75 0.75 18.75 2.03571V12.3214C18.75 12.3214 18.75 13.6071 17.4643 13.6071H2.03571C2.03571 13.6071 0.75 13.6071 0.75 12.3214V2.03571C0.75 2.03571 0.75 0.75 2.03571 0.75Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <Path
        d="M18.4594 1.22168L11.4788 6.59082C10.9831 6.97213 10.3753 7.17887 9.74996 7.17887C9.12459 7.17887 8.51677 6.97213 8.0211 6.59082L1.04053 1.22168"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </Svg>
  );
});
